import React, { useMemo } from 'react'

interface AddressLinkProps {
  address: string
  className?: string
}

const AddressLink = React.memo(
  ({ address, className = 'text-blue-600 hover:text-blue-800 underline' }: AddressLinkProps) => {
    const googleMapsUrl = useMemo(
      () => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`,
      [address],
    )

    return (
      <a href={googleMapsUrl} target="_blank" rel="noopener noreferrer" className={className}>
        {address}
      </a>
    )
  },
)

AddressLink.displayName = 'AddressLink'

export default AddressLink
